import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import StudentMembershipDetail from "./../../component/Modal/StudentMembershipDetail";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { toast } from "react-toastify";
import { requestToDeleteAccount, getAccountDeletionRequests } from "../../api/authentications";
import moment from "moment";

function AccountCancellation() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  // const list = useSelector((state) => state.student.list);
  const [reason, setReason] = useState("");
  const [requests, setRequests] = useState([]);
  const [hasPendingRequest, setHasPendingRequest] = useState(false);

  React.useEffect(() => {
    fetchRequests();
  }, [id]);

  const fetchRequests = () => {
    let payload = id ? { studentId: id } : {};
    getAccountDeletionRequests(payload).then((res) => {
      if (res?.code === 1) {
        setRequests(res?.data?.requests || []);
        const isPending = (res?.data?.requests || []).some(req => req.status === "pending");
        setHasPendingRequest(isPending);
      }
    });
  };

  const handleCancel = () => {
    if (reason) {
      let payload = {};
      if (id) {
        payload = {
          reason,
          studentId: id ? id : "",
        };
      } else {
        payload = {
          reason,
        };
      }
      requestToDeleteAccount(payload).then((res) => {
        if (res?.code === 1) {
          fetchRequests();
          setReason("");
          toast.success(res?.message, { autoClose: false, closeButton: true });
        } else {
          toast.error(res?.message, { autoClose: false, closeButton: true });
        }
      });
    } else {
      toast.error("Kindly mention the reason for cancellation of the account.", { autoClose: false, closeButton: true });
    }
  };
  return (
    <section className="sec-bg py-5 bottom-space">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-sm-12 col-md-12 col-lg-12 mb-3 text-center">
            <h3>
              {location?.pathname?.includes("student")
                ? "Request Student Removal"
                : "Request Account Cancellation"}
            </h3>
            {/* <p>Are you sure you want to cancel your account ?</p> */}
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-sm-12 col-md-12 col-lg-12 mb-4">
            <div className="account-Cancellation">
              {/* <Carousel
                responsive={responsive}
                removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}
                infinite={true}
                showDots={true}
                renderDotsOutside={true}
              >
                {list?.length > 0 ? (
                  list?.map((item, i) => {
                    return <StudentMembershipDetail />;
                  })
                ) : (
                  <div>No data found.</div>
                )}
              </Carousel> */}

              <div className="d-flex flex-direction-column">
                <label className="fw-bold theme-color">
                  Why do you want to cancel your account
                </label>
                {hasPendingRequest && (
                  <div className="alert alert-warning mb-2">
                    You already have a pending deletion request. Please wait until it is processed.
                  </div>
                )}
                <textarea
                  rows={5}
                  className="textArea form-control"
                  value={reason}
                  onChange={(e) => {
                    setReason(e.target.value);
                  }}
                  disabled={hasPendingRequest}
                ></textarea>
                <div className="deleteAccountButtonContainer">
                  <button
                    type="button"
                    className="btn btn-view btn-accept  fs-6 mb-1 "
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    Back
                  </button>
                  {!hasPendingRequest && (
                    <button
                      type="button"
                      className="btn btn-view btn-accept  fs-6 mb-1 "
                      onClick={handleCancel}
                    >
                      Cancel Account
                    </button>
                  )}
                </div>

              </div>
            </div>
          </div>
        </div>

        {requests.length > 0 && (
          <div className="row mt-2 justify-content-center">
            <div className="col-sm-12 col-md-10 col-lg-8">
              <h4 className="fw-bold theme-color mb-3 text-center">Request History</h4>
              <div className="table-responsive">
                <table className="table table-bordered text-center align-middle">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: "25%" }}>Date</th>
                      <th style={{ width: "50%" }}>Reason</th>
                      <th style={{ width: "25%" }}>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {requests.map((req, index) => (
                      <tr key={index}>
                        <td>{moment(req.createdAt).format("DD MMM YYYY")}</td>
                        <td className="text-start">
                          <div>{req.reason}</div>
                          {req.status === 'rejected' && req.reject_reason && (
                            <div className="text-danger mt-2">
                              <strong>Rejection Reason:</strong> {req.reject_reason}
                            </div>
                          )}
                        </td>
                        <td className="text-capitalize align-middle">
                          <span className={`badge bg-${req.status === 'pending' ? 'warning text-dark' : req.status === 'accepted' || req.status === 'deleted' ? 'success' : 'danger'}`}>
                            {req.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default AccountCancellation;
